if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.items = [];
        this.currentIndex = 0;
        this.prevBtn = null;
        this.nextBtn = null;
        this.counter = null;
        this._onKeyDown = this._onKeyDown.bind(this);

        this.addEventListener('pointerup', function (e) {
          var dialog = this.querySelector('.product-media-modal__dialog');
          if (e.target !== this && dialog && dialog.contains(e.target)) {
            e.stopImmediatePropagation();
          }
        }.bind(this), true);
      }

      show(opener) {
        this._sourceRect = this._captureSourceRect(opener);
        super.show(opener);
        this._buildNav();
        this._collectItems();
        this._showByOpener();
        this._playZoomIn();
        document.addEventListener('keydown', this._onKeyDown);
      }

      hide() {
        document.removeEventListener('keydown', this._onKeyDown);
        super.hide();
        var gallery = document.querySelector('media-gallery');
        if (gallery) {
          gallery.querySelectorAll('video[autoplay]').forEach(function (v) {
            v.play().catch(function () {});
          });
        }
      }

      _captureSourceRect(opener) {
        if (!opener) return null;
        var img = opener.querySelector('img') || opener.closest('.product__media-item')?.querySelector('img');
        if (!img) return null;
        return img.getBoundingClientRect();
      }

      _playZoomIn() {
        var content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        var active = this.items[this.currentIndex];
        if (!active) return;

        var src = this._sourceRect;
        if (!src) return;

        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var cx = src.left + src.width / 2;
        var cy = src.top + src.height / 2;

        var dx = cx - vw / 2;
        var dy = cy - vh / 2;
        var scale = Math.min(src.width / vw, src.height / vh);
        scale = Math.max(scale, 0.15);

        active.style.animation = 'none';
        active.offsetHeight;
        active.style.setProperty('--lb-from-x', dx + 'px');
        active.style.setProperty('--lb-from-y', dy + 'px');
        active.style.setProperty('--lb-from-scale', scale);
        active.style.animation = '';
        active.classList.remove('active');
        void active.offsetWidth;
        active.classList.add('active');
      }

      _buildNav() {
        if (this.querySelector('.lightbox-nav')) return;
        var dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog) return;

        this.prevBtn = document.createElement('button');
        this.prevBtn.type = 'button';
        this.prevBtn.className = 'lightbox-nav lightbox-nav--prev';
        this.prevBtn.setAttribute('aria-label', 'Previous image');
        this.prevBtn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>';
        this.prevBtn.addEventListener('click', (e) => { e.stopPropagation(); this.go(-1); });

        this.nextBtn = document.createElement('button');
        this.nextBtn.type = 'button';
        this.nextBtn.className = 'lightbox-nav lightbox-nav--next';
        this.nextBtn.setAttribute('aria-label', 'Next image');
        this.nextBtn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg>';
        this.nextBtn.addEventListener('click', (e) => { e.stopPropagation(); this.go(1); });

        this.counter = document.createElement('div');
        this.counter.className = 'lightbox-counter';

        dialog.appendChild(this.prevBtn);
        dialog.appendChild(this.nextBtn);
        dialog.appendChild(this.counter);
      }

      _collectItems() {
        var content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        this.items = Array.from(content.querySelectorAll('[data-media-id]'));
        this.setAttribute('data-count', this.items.length);
      }

      _showByOpener() {
        if (!this.items.length) return;
        var openerId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : '';
        var idx = this.items.findIndex(function (el) {
          return el.getAttribute('data-media-id') === openerId;
        });
        this.currentIndex = idx >= 0 ? idx : 0;
        this._activate();
      }

      go(delta) {
        if (!this.items.length) return;
        this.currentIndex = (this.currentIndex + delta + this.items.length) % this.items.length;
        this._activate();
      }

      _activate() {
        var self = this;
        this.items.forEach(function (el) {
          el.classList.remove('active');
          var v = el.querySelector('video');
          if (v) { v.pause(); v.currentTime = 0; }
        });
        var active = this.items[this.currentIndex];
        if (active) {
          active.classList.add('active');
          var dm = active.querySelector('deferred-media');
          if (dm) {
            if (dm.querySelector('template') && !dm.getAttribute('loaded')) {
              dm.loadContent(false);
            }
            if (dm.getAttribute('loaded')) {
              var poster = dm.querySelector(':scope > img');
              if (poster) poster.style.display = 'none';
              var playBtn = dm.querySelector('.play-button');
              if (playBtn) playBtn.style.display = 'none';
            }
          }
          var vid = active.querySelector('video');
          if (vid) {
            vid.muted = true;
            vid.play().catch(function () {});
          }
        }
        this._updateCounter();
      }

      _updateCounter() {
        if (!this.counter) return;
        this.counter.textContent = (this.currentIndex + 1) + ' / ' + this.items.length;
      }

      _onKeyDown(e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
      }

      showActiveMedia() {
        /* no-op: replaced by _showByOpener */
      }
    }
  );
}
